import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 791 1024'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M185.147 607.289l80.162-80.162c-5.56-15.127-8.533-31.547-8.533-48.614 0-80.937 62.448-145.713 140.541-145.713 18.618 0 36.331 3.362 52.493 9.826l51.717-51.717c-29.22-9.568-59.604-15.257-91.281-16.549-61.931-2.327-119.467 13.446-173.253 43.442-73.826 41.374-133.689 99.814-194.198 159.418 43.96 43.442 86.238 87.531 134.723 124.638 2.586 1.939 5.042 3.749 7.628 5.43zM715.248 437.915c-28.962-30.255-59.604-58.57-93.091-83.265l74.602-74.602-46.158-46.158-486.788 486.788 46.158 46.158 98.263-98.263c19.911 5.56 40.598 9.18 62.19 10.731 64.388 4.784 124.638-8.792 181.657-38.012 78.093-39.822 139.766-100.331 201.568-161.875-12.929-14.093-25.471-27.927-38.4-41.503zM399.515 621.511c-13.446 0-26.505-1.81-38.917-5.301l48.097-48.097c10.473-1.293 20.687-4.525 30.513-9.568 26.505-13.705 44.735-40.727 48.226-69.172l48.097-48.097c2.844 11.507 4.396 23.661 4.396 36.073 0.129 79.386-62.836 144.162-140.412 144.162zM318.448 435.071c-7.758 15.257-10.99 32.194-9.697 48.743l97.487-97.616c-35.685-4.008-70.594 15.515-87.79 48.873z'
    />
  </svg>
)

export default SVG